import React from 'react';
import {
  KB_STATUS_LABELS,
  KB_STATUS_STYLES,
  SOURCE_TYPE_LABELS,
} from '../../KnowledgeBases/constants';

function KnowledgeBaseMultiSelect({
  id,
  label = 'Bases de conhecimento',
  hint,
  knowledgeBases = [],
  selectedIds = [],
  onChange,
  error,
}) {
  const selectedSet = new Set(selectedIds);

  const toggle = (kbId) => {
    if (selectedSet.has(kbId)) {
      onChange(selectedIds.filter((item) => item !== kbId));
      return;
    }
    onChange([...selectedIds, kbId]);
  };

  return (
    <div>
      {label && (
        <p className="block text-sm font-medium text-slate-700 mb-2">{label}</p>
      )}

      {knowledgeBases.length === 0 ? (
        <div className="rounded-xl border border-dashed border-slate-300 bg-white px-4 py-3">
          <p className="text-sm text-content-muted">
            Nenhuma base de conhecimento disponível. Cadastre uma base válida para vincular aos comportamentos.
          </p>
        </div>
      ) : (
        <div
          id={id}
          className={`rounded-xl border bg-white divide-y divide-surface-border ${
            error ? 'border-red-300' : 'border-surface-border'
          }`}
        >
          {knowledgeBases.map((kb) => {
            const checked = selectedSet.has(kb.id);
            const statusLabel = KB_STATUS_LABELS[kb.status] || kb.status;
            const statusStyle = KB_STATUS_STYLES[kb.status] || KB_STATUS_STYLES.pending;
            const sourceLabel = SOURCE_TYPE_LABELS[kb.source_type] || kb.source_type;

            return (
              <label
                key={kb.id}
                className="flex items-start gap-3 px-4 py-3 cursor-pointer hover:bg-slate-50/80 transition-colors"
              >
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() => toggle(kb.id)}
                  className="mt-1 h-4 w-4 rounded border-slate-300 text-forge-600 focus:ring-forge-500"
                />
                <span className="min-w-0 flex-1">
                  <span className="flex flex-wrap items-center gap-2">
                    <span className="text-sm font-medium text-content-primary">{kb.name}</span>
                    <span
                      className={`text-[11px] px-2 py-0.5 rounded-full border ${statusStyle}`}
                    >
                      {statusLabel}
                    </span>
                    {sourceLabel && (
                      <span className="text-[11px] text-content-muted">{sourceLabel}</span>
                    )}
                  </span>
                  {kb.source_ref && (
                    <span className="block text-xs text-content-muted mt-1 truncate">
                      {kb.source_ref}
                    </span>
                  )}
                </span>
              </label>
            );
          })}
        </div>
      )}

      {hint && !error && (
        <p className="mt-1.5 text-xs text-content-muted">{hint}</p>
      )}
      {error && <p className="mt-1.5 text-xs text-red-600">{error}</p>}
      {selectedIds.length > 0 && (
        <p className="mt-1.5 text-xs text-content-secondary">
          {selectedIds.length} base{selectedIds.length > 1 ? 's' : ''} selecionada
          {selectedIds.length > 1 ? 's' : ''}
        </p>
      )}
    </div>
  );
}

export default KnowledgeBaseMultiSelect;
